// src/api/tresorerieApi.js
import axios from 'axios';

const API_URL = '/api/flux-tresorerie';

export const fetchFluxTresorerie = async (filters) => {
  const response = await axios.get(API_URL, { params: filters });
  return response.data;
};

export const createFluxTresorerie = async (fluxData) => {
  const response = await axios.post(API_URL, fluxData);
  return response.data;
};
